import { Box, Divider, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../../../api/hooks/useAPI";
import { controlKeys, entityKeys } from "../../../../../../api/queryKeys";
import LoadingIcon from "../../../../../../components/LoadingIcon";
import EntityDrawer from "../../../../../../scenes/stack/environment/components/EntityDrawer/EntityDrawer";
import ControlActivityLogs from "./ActivityLogs/ControlActivityLogs";
import ControlDetailsSection from "./ControlDetailsSection";
import { HeaderControlSection } from "./ControlTab";

export default function ActivityTab({ fullControl, demoMode }) {
  const { getControlActivityLogs, fetchEntityById } = useAPI();
  const [searchParams, setSearchParams] = useSearchParams();

  const logsQuery = useQuery({
    queryKey: controlKeys.controlActivityLogs(fullControl.control_id),
    queryFn: () => getControlActivityLogs(fullControl.control_id),
    select: (response) =>
      response.data.filter((log) => !log.is_deleted && log.display),
  });

  const entityParam = searchParams.get("entity");
  const drawerEntityID = entityParam ? decodeURIComponent(entityParam) : null;

  const entityQuery = useQuery({
    queryKey: entityKeys.entity(drawerEntityID),
    queryFn: () => fetchEntityById(drawerEntityID),
    select: (response) => response.data,
    enabled: Boolean(drawerEntityID),
  });

  const openDrawer =
    drawerEntityID && entityQuery.isSuccess && entityQuery.data;
  const drawerEntity = entityQuery.data;

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" flexDirection="column" gap={2}>
        <HeaderControlSection fullControl={fullControl} />
        <ControlDetailsSection fullControl={fullControl} demoMode={demoMode} />
        <Divider sx={{ width: "100%", marginTop: "4px" }} />
      </Box>
      <Box display="flex" flexDirection="column">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          height="32px"
        >
          <Typography variant="subtitle1">Activity</Typography>
          {/* TODO: V2 - Subscribe button */}
        </Box>
        <Box display="flex" flexDirection="column" gap={2}>
          {logsQuery.isLoading ? (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="50px"
            >
              <LoadingIcon size={22} />
            </Box>
          ) : logsQuery.isSuccess && logsQuery.data.length > 0 ? (
            <ControlActivityLogs sortedLogs={logsQuery.data} />
          ) : logsQuery.isError ? (
            <Box display="flex" alignItems="center" height="40px">
              <Typography variant="body2">
                Error loading activity logs...
              </Typography>
            </Box>
          ) : (
            <Box display="flex" alignItems="center" height="40px">
              <Typography variant="body2">
                No activity logs for this control
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <EntityDrawer
        openDrawer={openDrawer}
        selectedEntity={drawerEntity}
        onClose={() => {
          const params = new URLSearchParams(searchParams);
          params.delete("entity");
          setSearchParams(params.toString());
        }}
      />
    </Box>
  );
}
